import auroraSpotterIcon from '../assets/img/projects/auroraspotter/icon.webp';
import auroraSpotterScreen from '../assets/img/projects/auroraspotter/screen.webp';
import auroraSpotterCover from '../assets/img/projects/auroraspotter/cover.webp';
import auroraSpotterWebsite from '../assets/img/projects/auroraspotter/website.webp';
import launchXIcon from '../assets/img/projects/launchx/icon.webp';
import launchXScreen from '../assets/img/projects/launchx/screen.webp';
import launchXCover from '../assets/img/projects/launchx/cover.webp';
import launchXWebsite from '../assets/img/projects/launchx/website.webp';
import lunaScopeIcon from '../assets/img/projects/lunascope/icon.webp';
import lunaScopeScreen from '../assets/img/projects/lunascope/screen.webp';
import lunaScopeCover from '../assets/img/projects/lunascope/cover.webp';
import sunupIcon from '../assets/img/projects/sunup/icon.webp';
import sunupScreen from '../assets/img/projects/sunup/screen.webp';
import sunupWebsite from '../assets/img/projects/sunup/website.webp';
import sunupRoll1 from '../assets/img/projects/sunup/roll-1.webp';
import sunupRoll2 from '../assets/img/projects/sunup/roll-2.webp';
import sunupRoll3 from '../assets/img/projects/sunup/roll-3.webp';
import sunupRoll4 from '../assets/img/projects/sunup/roll-4.webp';
import sunupRoll5 from '../assets/img/projects/sunup/roll-5.webp';
import sunupRoll6 from '../assets/img/projects/sunup/roll-6.webp';
import slingpinIcon from '../assets/img/projects/slingpin/icon.webp';
import slingpinScreen from '../assets/img/projects/slingpin/screen.webp';
import slingpinFrame1 from '../assets/img/projects/slingpin/frame-1.webp';
import slingpinFrame2 from '../assets/img/projects/slingpin/frame-2.webp';
import slingpinFrame3 from '../assets/img/projects/slingpin/frame-3.webp';
import freifensterIcon from '../assets/img/projects/freifenster/icon.svg?url';
import freifensterScreen from '../assets/img/projects/freifenster/screen.webp';
import freifensterWebsite from '../assets/img/projects/freifenster/website.webp';
import johannesBrenzIcon from '../assets/img/projects/johannes-brenz/icon.webp';
import johannesBrenzScreen from '../assets/img/projects/johannes-brenz/screen.webp';
import johannesBrenzCover from '../assets/img/projects/johannes-brenz/cover.webp';
import johannesBrenzWebsite from '../assets/img/projects/johannes-brenz/website.webp';
import designIcon from '../assets/img/projects/design/icon.webp';
import designShowcaseWide from '../assets/img/projects/design/showcase-wide.webp';
import designShowcaseTall from '../assets/img/projects/design/showcase-tall.webp';

export type ProjectSlug =
    | 'design'
    | 'sunup'
    | 'auroraspotter'
    | 'launchx'
    | 'lunascope'
    | 'slingpin'
    | 'freifenster'
    | 'johannes-brenz';

export type ProjectStatus = 'live' | 'launching' | 'inProgress';

export type ProjectOwnership = 'product' | 'lab' | 'clientWork';

export type ProjectCategory = 'app' | 'web';

export type Platform = 'ios' | 'android' | 'web';

export type ProjectLinkKind = 'appStore' | 'playStore' | 'website';

export interface ProjectLink {
    kind: ProjectLinkKind;
    href: string;
}

export type ProjectVisual =
    | { kind: 'photo'; image: string; credit?: string }
    | { kind: 'cover'; image: string; tallImage?: string }
    | { kind: 'filmstrip'; images: string[] }
    | { kind: 'frames'; images: string[] }
    | { kind: 'calendar' };

export type ProjectReach =
    | { kind: 'users'; count: number; precision: 'atLeast' | 'about' }
    | { kind: 'new' };

export interface Project {
    slug: ProjectSlug;
    name: string;
    iconSrc: string;
    screenSrc: string;
    websiteSrc?: string;
    visual: ProjectVisual;
    category: ProjectCategory;
    platforms: Platform[];
    stack: string[];
    localeCount: number;
    status: ProjectStatus;
    ownership: ProjectOwnership;
    usesAiInProduct: boolean;
    reach?: ProjectReach;
    links: ProjectLink[];
}

export const projects: Project[] = [
    {
        slug: 'design',
        name: 'Haukel Design',
        iconSrc: designIcon,
        screenSrc: designShowcaseTall,
        visual: { kind: 'cover', image: designShowcaseWide, tallImage: designShowcaseTall },
        category: 'web',
        platforms: ['web'],
        stack: ['Go', 'React', 'TypeScript'],
        localeCount: 1,
        status: 'launching',
        ownership: 'product',
        usesAiInProduct: true,
        reach: { kind: 'new' },
        links: [
            { kind: 'website', href: 'https://ai.haukel.com' }
        ]
    },
    {
        slug: 'launchx',
        name: 'LaunchX',
        iconSrc: launchXIcon,
        screenSrc: launchXScreen,
        websiteSrc: launchXWebsite,
        visual: { kind: 'photo', image: launchXCover, credit: 'NASA' },
        category: 'app',
        platforms: ['ios', 'android', 'web'],
        stack: ['React Native', 'Expo', 'TypeScript', '.NET'],
        localeCount: 7,
        status: 'live',
        ownership: 'product',
        usesAiInProduct: true,
        reach: { kind: 'users', count: 20000, precision: 'atLeast' },
        links: [
            { kind: 'website', href: 'https://launchx.haukel.com' },
            { kind: 'appStore', href: 'https://apps.apple.com/app/id6745711682' },
            { kind: 'playStore', href: 'https://play.google.com/store/apps/details?id=com.haukel.launchx' }
        ]
    },
    {
        slug: 'sunup',
        name: 'Sunup',
        iconSrc: sunupIcon,
        screenSrc: sunupScreen,
        websiteSrc: sunupWebsite,
        visual: { kind: 'filmstrip', images: [sunupRoll1, sunupRoll2, sunupRoll3, sunupRoll4, sunupRoll5, sunupRoll6] },
        category: 'app',
        platforms: ['ios', 'android', 'web'],
        stack: ['React Native', 'Expo', 'TypeScript', 'Go'],
        localeCount: 6,
        status: 'launching',
        ownership: 'product',
        usesAiInProduct: true,
        links: [
            { kind: 'website', href: 'https://sun-up.app' }
        ]
    },
    {
        slug: 'auroraspotter',
        name: 'AuroraSpotter',
        iconSrc: auroraSpotterIcon,
        screenSrc: auroraSpotterScreen,
        websiteSrc: auroraSpotterWebsite,
        visual: { kind: 'photo', image: auroraSpotterCover },
        category: 'app',
        platforms: ['ios', 'android', 'web'],
        stack: ['React Native', 'Expo', 'TypeScript', 'Go', 'Next.js'],
        localeCount: 14,
        status: 'live',
        ownership: 'lab',
        usesAiInProduct: false,
        reach: { kind: 'users', count: 200, precision: 'about' },
        links: [
            { kind: 'website', href: 'https://auroraspotter.com' },
            { kind: 'appStore', href: 'https://apps.apple.com/app/id6761315924' },
            { kind: 'playStore', href: 'https://play.google.com/store/apps/details?id=com.haukel.auroraspotter' }
        ]
    },
    {
        slug: 'lunascope',
        name: 'LunaScope',
        iconSrc: lunaScopeIcon,
        screenSrc: lunaScopeScreen,
        visual: { kind: 'photo', image: lunaScopeCover, credit: 'NASA SVS' },
        category: 'app',
        platforms: ['android'],
        stack: ['React Native', 'Expo', 'TypeScript', 'WebGL'],
        localeCount: 7,
        status: 'live',
        ownership: 'lab',
        usesAiInProduct: false,
        reach: { kind: 'users', count: 1000, precision: 'atLeast' },
        links: [
            { kind: 'playStore', href: 'https://play.google.com/store/apps/details?id=com.haukel.lunascope' }
        ]
    },
    {
        slug: 'slingpin',
        name: 'Slingpin',
        iconSrc: slingpinIcon,
        screenSrc: slingpinScreen,
        visual: { kind: 'frames', images: [slingpinFrame1, slingpinScreen, slingpinFrame3, slingpinFrame2] },
        category: 'app',
        platforms: ['android', 'ios'],
        stack: ['React Native', 'Expo', 'TypeScript', 'Skia'],
        localeCount: 2,
        status: 'live',
        ownership: 'lab',
        usesAiInProduct: true,
        reach: { kind: 'new' },
        links: [
            { kind: 'playStore', href: 'https://play.google.com/store/apps/details?id=com.haukel.slingpin' }
        ]
    },
    {
        slug: 'freifenster',
        name: 'Freifenster',
        iconSrc: freifensterIcon,
        screenSrc: freifensterScreen,
        websiteSrc: freifensterWebsite,
        visual: { kind: 'calendar' },
        category: 'web',
        platforms: ['web'],
        stack: ['Go', 'Vue', 'TypeScript'],
        localeCount: 1,
        status: 'live',
        ownership: 'lab',
        usesAiInProduct: false,
        reach: { kind: 'new' },
        links: [
            { kind: 'website', href: 'https://freifenster.de' }
        ]
    },
    {
        slug: 'johannes-brenz',
        name: 'Johannes-Brenz-Gemeinschafts­schule',
        iconSrc: johannesBrenzIcon,
        screenSrc: johannesBrenzScreen,
        websiteSrc: johannesBrenzWebsite,
        visual: { kind: 'photo', image: johannesBrenzCover },
        category: 'web',
        platforms: ['web'],
        stack: ['WordPress', 'PHP', 'JavaScript'],
        localeCount: 2,
        status: 'live',
        ownership: 'clientWork',
        usesAiInProduct: false,
        links: [
            { kind: 'website', href: 'https://jb-gms.de' }
        ]
    }
];

const SOFT_HYPHEN = /­/g;

export function plainProjectName(project: Project): string {
    return project.name.replace(SOFT_HYPHEN, '');
}

export function findProjectBySlug(slug: string): Project | undefined {
    return projects.find((project) => project.slug === slug);
}

export function getProject(slug: string): Project {
    const project = findProjectBySlug(slug);
    if (!project) throw new Error(`Unknown project slug "${slug}"`);
    return project;
}

export function projectsWithAi(): Project[] {
    return projects.filter((project) => project.usesAiInProduct);
}

export function projectsOwnedAs(ownership: ProjectOwnership): Project[] {
    return projects.filter((project) => project.ownership === ownership);
}

export function primaryLink(project: Project): ProjectLink | undefined {
    return project.links.find((link) => link.kind === 'website') ?? project.links[0];
}

const URL_PREFIX = /^[a-z]+:\/\/(www\.)?/i;

export function linkHost(link: ProjectLink): string {
    return link.href.replace(URL_PREFIX, '').split('/')[0];
}

export function findNeighbourProjects(slug: ProjectSlug): { previous: Project; next: Project } {
    const index = projects.findIndex((project) => project.slug === slug);

    return {
        previous: projects[(index - 1 + projects.length) % projects.length],
        next: projects[(index + 1) % projects.length]
    };
}
